<template>
  <vs-sidebar ref="navTaskSidebar" click-not-close position-right parent="body" default-index="1" color="primary" class="vs-con-loading__container add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{sidebarHeader}}</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar ref="sidebarScrollArea" class="vs-con-loading__container scroll-area--data-list-add-new pt-4 pb-6" :settings="settings" id="taskDetails">
      <div class="pl-6 pr-6 pb-6">
        <div>
          <div v-if="this.$siteTypeId() != 1">
            <div class="pb-1">
              <label>Task Classification</label>
              <v-select class="mb-3" ref="taskClassificationTypeDropdown" placeholder="Search / Select Task Classification"  :options="taskClassificationTypeList" v-model="taskClassificationTypeDropdown"></v-select>
            </div>
          </div>

          <label ref="nameLabel">Name</label>
          <vs-input autocomplete="off" class="w-full mb-3" v-model="formData.name"/>
          <label ref="videoLabel">Video</label>
          <b-overlay
            id="overlay-background"
            :show="videosLoading"
            variant="light"
            opacity="0.70"
            blur="2px"
            rounded="sm"
          >
            <v-select ref="videoDropdown" class="w-full mb-3 style-chooser" placeholder="Search / Select Video" :options="videos" v-model="videoDropdown" @search:blur="getVideo" @search:focus="hideElements" @input="hideElements"></v-select>
          </b-overlay>
          
          <label ref="quizLabel">Journal Quiz</label>
          <b-overlay
            id="overlay-background"
            :show="quizzesLoading"
            variant="light"
            opacity="0.70"
            blur="2px"
            rounded="sm"
          >
            <v-select ref="quizDropdown" class="w-full mb-3 style-chooser" placeholder="Search / Select Journal Quiz" :options="quizzes" v-model="quizDropdown" @search:blur="getQuizQuestions" @search:focus="hideElements" @input="hideElements"></v-select>
          </b-overlay>
        </div>

        <div class="mt-3" style="display: inline-grid;">
          <label>Task Number</label>
          <vs-input-number class="numberinput" onClick="this.select();" v-model="formData.number" min="0" />
        </div>

        <div id="videojs-container" class="player" v-show="false">
          <video id="video-quiz-video-player" class="video-js" ref="videojs" controls></video>
        </div>
        
        <div class="pt-2 pb-4" v-if="showQuestions">
          <vs-divider/>
          <ul>
            <li v-for="(_question, index) in formData.questions" :key="index">
              <vx-card style="margin-bottom: 15px;">
                <div class="vx-row">
                  <div class="vx-col w-full">
                    <p class="pt-2 float-left">Question</p>
                    <vs-button id="remove-option-button" radius size="small" type="border" color="danger" icon-pack="feather" icon="icon-x" @click="deleteRow(index)"></vs-button>
                  </div>
                </div>
                <v-select v-model="_question.dropdownValue" class="w-full style-chooser my-2" placeholder="Search / Select a Question" :options="questions"></v-select>
                <div v-if="_question.dropdownValue" class="vx-row">
                  <div class="vx-col w-full">
                    <div class="vx-row">
                      <div class="vx-col w-full">
                        <cleave
                          id="time"
                          v-model="_question.time"
                          class="form-control"
                          :raw="false"
                          :options="options.time"
                          placeholder="mm:ss"
                        />
                      </div>
                    </div>
                    <div v-if="videoLengthString" class="vx-row mt-2">
                      <div class="vx-col text-center w-full">
                        <small><p>Selected video's length:&nbsp;<strong>{{ videoLengthString }}</strong></p></small>
                      </div>
                    </div>
                  </div>
                </div>
              </vx-card>
            </li>
          </ul>
          <div>
            <vs-button ref="optionsAdd" class="w-full cursor-pointer" type="border" color="success" icon-pack="feather" icon="icon-plus" @click="addOptions"></vs-button><!-- v-scroll-to="'#charlook'" -->
          </div>
        </div>

        <div v-if="this.$siteTypeId() != 1">
          <vs-divider>Outcomes</vs-divider>
          
          <div class="pb-1">
            <label>Assessment Criteria</label>
            <v-select class="mb-2" ref="assessmentCriteriaDropdown" placeholder="Search / Select Assessment Criteria"  :options="assessmentCriteriaList" v-model="assessmentCriteriaDropdown"></v-select>
          </div>

          <div class="pb-1">
            <label>Essential Embedded Knowledge</label>
            <v-select class="mb-2" ref="eekDropdown" placeholder="Search / Select EEK"  :options="eekList" v-model="eekDropdown"></v-select>
          </div>

          <div class="pb-1">
            <label>Unit Standard</label>
            <v-select class="mb-2" ref="unitStandardDropdown" placeholder="Search / Select Unit Standard"  :options="unitStandardList" v-model="unitStandardDropdown"></v-select>
          </div>

          <div class="pb-1">
            <label>Spesific Outcome</label>
            <v-select class="mb-2" ref="spesificOutcomeDropdown" placeholder="Search / Select Spesific Outcome"  :options="spesificOutcomeList" v-model="spesificOutcomeDropdown"></v-select>
          </div>
          
        </div>

        <vs-divider>Go To</vs-divider>

        <div class="pt-1">
          <vs-radio v-model="gotoRadio" vs-value="existingTask">Existing Task</vs-radio>
        </div>
        <div class="pt-2">
          <vs-radio v-model="gotoRadio" vs-value="newTask">Create New Task</vs-radio>
        </div>
        <div class="pt-2">
          <vs-radio v-model="gotoRadio" vs-value="none">None</vs-radio>
        </div>


        <div class="pt-4" v-show="gotoRadio == 'existingTask'">
          <label>Go To</label>
          <vs-select placeholder="Search / Select Go To task" class="w-full pb-3" vs-multiple autocomplete v-model="formData.goTo">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in gotoList" />
          </vs-select>
          <div>
            <div style="margin-bottom: 8px; margin-top: 2px;">
              <vs-checkbox color="success" v-model="formData.useCoins">Coins</vs-checkbox>
            </div>
            <div v-if="formData.useCoins && gotoRadio == 'existingTask'">
              <div style="display: flex; margin-bottom: 8px; margin-left: 4px;">
                <vs-switch color="success" v-model="formData.isCoinsRecurring">
                  <span slot="on">Recurring</span>
                  <span slot="off">Once Only</span>
                </vs-switch>
                <vs-switch style="margin-left: 10px;" color="success" v-model="formData.addCoins">
                  <span slot="on">Add</span>
                  <span slot="off">Deduct</span>
                </vs-switch>
              </div>
              <label style="margin-left: 5px;">Coin Value</label>
              <vs-input autocomplete="off" v-validate="'numeric'" onClick="this.select();" name="Coin Value" style="margin-bottom: 5px; margin-left: 5px; width: 150px;" v-model="formData.coinValue" />
              <span style="margin-left: 5px;" class="text-danger text-sm" v-show="errors.has('Coin Value')">{{ errors.first('Coin Value') }}</span>
            </div>
          </div>
        </div>

        <div class="pt-4" v-show="gotoRadio == 'newTask'">
          <label>New Task Type</label>
          <vs-select placeholder="Search / Select a Task Type" class="w-full pb-3" vs-multiple autocomplete v-model="formData.taskTypeId">
            <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in taskTypeList" />
          </vs-select>
          <div>
            <div style="margin-bottom: 8px; margin-top: 2px;">
              <vs-checkbox color="success" v-model="formData.useCoins">Coins</vs-checkbox>
            </div>
            <div v-if="formData.useCoins && gotoRadio == 'newTask'">
              <div style="display: flex; margin-bottom: 8px; margin-left: 4px;">
                <vs-switch color="success" v-model="formData.isCoinsRecurring">
                  <span slot="on">Recurring</span>
                  <span slot="off">Once Only</span>
                </vs-switch>
                <vs-switch style="margin-left: 10px;" color="success" v-model="formData.addCoins">
                  <span slot="on">Add</span>
                  <span slot="off">Deduct</span>
                </vs-switch>
              </div>
              <label style="margin-left: 5px;">Coin Value</label>
              <vs-input autocomplete="off" v-validate="'numeric'" onClick="this.select();" name="Coin Value" style="margin-bottom: 5px; margin-left: 5px; width: 150px;" v-model="formData.coinValue" />
              <span style="margin-left: 5px;" class="text-danger text-sm" v-show="errors.has('Coin Value')">{{ errors.first('Coin Value') }}</span>
            </div>
          </div>
        </div>
      </div>
    </VuePerfectScrollbar>

    <div class="flex flex-wrap items-center justify-center pb-4 pt-1" slot="footer">
      <vs-button class="mr-4 vs-con-loading__container cursor-pointer" color="success" @click="addEditVideoQuiz" :disabled="isDisabled" ref="addupdateButton">{{buttoncaption}}</vs-button>
      <vs-button color="danger" class="mr-4 vs-con-loading__container cursor-pointer" @click="deleteApproach" v-show="formData.id" ref="deleteButton">Delete</vs-button>
      <vs-button type="border" class="ml-4 cursor-pointer" color="warning" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import vSelect from 'vue-select'
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { setTimeout } from 'timers';
import videojs from "video.js";
import streaming from "@videojs/http-streaming";
import Cleave from 'vue-cleave-component'
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    moduleId: {
      type: String,
      required: true
    },
    nodeSelected: {
      type: Object,
      required: false
    },
    buttoncaption: {
      type: String,
      required: false
    },
    sidebarHeader: {
      type: String,
      required: false
    },
    taskClassificationTypes: {
      type: Array,
      required: false
    },
    courseId: {
      type: String,
      required: true
    },
    gotoList: {
      type: Array,
      required: false
    },
    sourceTaskId: {
      type: Number,
      required: false
    },
    taskTypeList: {
      type: Array,
      required: false
    }
  },

  data() {
    return {
      backgroundLoading:'#fff',
      formData: {
        id: 0,
        name: "",
        moduleId: 0,
        videoId: 0,
        quizId: 0,
        questions: [],
        sourceTaskId: 0,
        taskTypeId: 0,
        hasLogs: false,
        number: 0,
        goTo: "",
        useCoins: false,
        isCoinsRecurring: false,
        addCoins: true,
        coinValue: "",
        unitStandardId: 0,
        spesificOutcomeId: 0,
        assessmentCriteriaId: 0,
        eekId: 0,
        taskClassificationTypeId: null,    
      },
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      videoDropdown: 0,
      videos: [],
      quizDropdown: 0,
      quizzes: [],
      videoLengthSecs: 0,
      videoLengthString: null,
      showQuestions: false,
      options: {
        time: {
          time: true,
          timePattern: ['m', 's'],
        }
      },
      spesificOutcomeDropdown: null,
      unitStandardDropdown: null,
      assessmentCriteriaDropdown: null,
      eekDropdown: null,
      taskClassificationTypeDropdown: null,
      invalidTimes: [],
      videosLoading: false,
      quizzesLoading: false,
      questions: [],
      gotoRadio: "none",
      spesificOutcomeList: [],
      unitStandardList: [],
      assessmentCriteriaList: [],
      eekList: [],
      taskClassificationTypeList: [],
      taskClassificationTypeText: null,
    };
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
    videojs,
    streaming,
    Cleave
  },
  computed: {
    isDisabled: function() {
      return !(this.videoDropdown && this.quizDropdown && this.formData.name);
    },
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        var self = this;
        if (!val) {
          self.$emit("closeSidebar");
          if (self.$refs.addupdateButton) {
            self.$vs.loading.close(self.$refs.addupdateButton.$el);
          }
          self.initValues();
        }
      }
    },
  },
  watch: {
    isSidebarActive: function(val) {
      if(val){
        var self = this;

        var goToDisplayValue = 0;
        if(self.nodeSelected.videoQuizTask)
          goToDisplayValue = self.nodeSelected.videoQuizTask.goTo;
        else
          goToDisplayValue = 0;

        self.formData.courseId = self.courseId;
        self.taskClassificationTypeList = self.taskClassificationTypes;

        self.getEEK();
        self.getUnitStandard();
        self.getSpesificOutcome();
        self.GetAssessmentCriteria();
        
        if(self.nodeSelected.id){

          self.taskClassificationTypeDropdown = self.taskClassificationTypeList.filter(function(item){
            return item.value == self.nodeSelected.taskClassificationTypeId;
          })[0];

          self.getVideosList(function() {
            if (self.nodeSelected.id) {
              self.videoDropdown = self.videos.filter(function(item){return item.value == self.nodeSelected.videoQuizTask.videoId;})[0];

              self.getVideo();
            }
          });
          self.getQuizzesList(function() {
            if (self.nodeSelected.id) {
              self.quizDropdown = self.quizzes.filter(function(item){return item.value == self.nodeSelected.videoQuizTask.quizId;})[0];

              if(self.nodeSelected.videoQuizTask.questions.length != 0) {
                self.formData.questions = self.nodeSelected.videoQuizTask.questions;

                self.getQuizQuestions(function() {
                  self.formData.questions.forEach(item => {
                    item.dropdownValue = self.questions.filter(function(q){return q.value == item.quizQuestionId;})[0];
                  });
                })
              }
              else {
                self.getQuizQuestions();
              }
            }
          });

          self.formData.id = self.nodeSelected.id;
          self.formData.name = self.nodeSelected.name;
          self.formData.moduleId = self.moduleId;

          if (self.nodeSelected.number)
            self.formData.number = self.nodeSelected.number;
          else
            self.formData.number = 0;

          if(goToDisplayValue != 0)
            self.formData.goTo = self.gotoList.filter(function(item){ return item.text.split(" ")[0] == goToDisplayValue; })[0].value;

          if(self.formData.goTo){
            self.gotoRadio = "existingTask";
          } else {
            self.gotoRadio = "none";
          }

          self.formData.sourceTaskId = self.sourceTaskId;

          self.formData.hasLogs = self.nodeSelected.videoQuizTask.hasLogs;
          self.formData.useCoins = self.nodeSelected.videoQuizTask.coinValue ? true : false;
          self.formData.addCoins = self.nodeSelected.videoQuizTask.coinValue > 0 ? true : false;
          self.formData.isCoinsRecurring = self.nodeSelected.videoQuizTask.isCoinsRecurring;
          self.formData.coinValue = self.nodeSelected.videoQuizTask.coinValue > 0 ? self.nodeSelected.videoQuizTask.coinValue : (self.nodeSelected.videoQuizTask.coinValue * -1);
          self.showQuestions = true;
        }else{
          this.initValues(self.sourceTaskId || 0);
          self.getVideosList();
          self.getQuizzesList();
        }
      }else {
        var scrollOptions = {
          container: '#taskDetails',
          easing: 'ease-in',
          offset: -10000,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(this.$refs["nameLabel"], 0, scrollOptions);
      }
    },
  },
  methods: {
    getEEK(){
      var self =this;

      var onSuccess = function (response) {
        self.eekList = response.data.map(function(item) {return {value: item.value,label: item.text}});
        if(self.nodeSelected.id){
          self.essentialEmbeddedKnowledgeDropdown = self.eekList.filter(function(item){return item.value == self.nodeSelected.essentialEmbeddedKnowledgeId})[0];
        }
      }

      self.$ajaxGet(self, "Course/EEK?courseId=" + self.courseId, onSuccess);
    },
    getUnitStandard(){
      var self =this;

      var onSuccess = function (response) {
        self.unitStandardList = response.data.map(function(item) {return {value: item.value,label: item.text}});
         if(self.nodeSelected.id){
          self.unitStandardDropdown = self.unitStandardList.filter(function(item){return item.value == self.nodeSelected.unitStandardId})[0];
        }
      }

      self.$ajaxGet(self, "Course/UnitStandard?courseId=" + self.courseId, onSuccess);
    },
    getSpesificOutcome(){
      var self =this;

      var onSuccess = function (response) {
        self.spesificOutcomeList = response.data.map(function(item) {return {value: item.value,label: item.text}});
        if(self.nodeSelected.id){
          self.spesificOutcomeDropdown = self.spesificOutcomeList.filter(function(item){return item.value == self.nodeSelected.spesificOutcomeId})[0];
        }
      }

      self.$ajaxGet(self, "Course/SpecificOutcome?courseId=" + self.courseId, onSuccess);
    },
    GetAssessmentCriteria(){
      var self =this;

      var onSuccess = function (response) {     
        self.assessmentCriteriaList = response.data.map(function(item) {return {value: item.value,label: item.text}});
        if(self.nodeSelected.id){
          self.assessmentCriteriaDropdown = self.assessmentCriteriaList.filter(function(item){return item.value == self.nodeSelected.assessmentCriteriaId})[0];
        }
      }

      self.$ajaxGet(self, "Course/AssesmentCriteria?courseId=" + self.courseId, onSuccess);
    },
    initValues(val) {
      this.gotoRadio = "none";
      var oldVideoElement = document.getElementsByClassName("video-js")[0];
      if (oldVideoElement) {
        oldVideoElement.remove();
      }
      this.formData.id = 0;
      this.formData.name = "";
      this.formData.moduleId = this.moduleId;
      this.formData.videoId = 0;
      this.formData.quizId = 0;
      this.formData.number = 0;
      this.formData.goTo = "";
      this.formData.sourceTaskId = 0;
      this.formData.questions = [];
      this.formData.useCoins = false;
      this.formData.addCoins = true;
      this.formData.isCoinsRecurring = false;
      this.formData.coinValue = "";
      this.showQuestions = false;
      this.spesificOutcomeDropdown = null;
      this.unitStandardDropdown = null;
      this.assessmentCriteriaDropdown = null;
      this.essentialEmbeddedKnowledgeDropdown = null;
      this.taskClassificationTypeDropdown = null;

      if(val){
        this.formData.sourceTaskId = val;
      }
      
      this.formData.taskTypeId = "";
      this.videoDropdown = 0;
      this.quizDropdown = 0;

      this.videoLengthSecs = 0;
      this.videoLengthString = null;
      this.errors.clear();
    },
    getVideosList(whenDone) {
      const self = this;
      self.videosLoading = true;

      var onSuccess = function(response) {
        self.videos = response.data.map((item) => {return {label: item.name, value: item.id, url: item.url} });

        if (whenDone && typeof whenDone == "function") {
          whenDone();
        }
      };
      var onFinally = function () {
        self.videosLoading = false;
      };

      self.$ajaxGet(self, "Video/GetSelectListVideosByType", onSuccess, onFinally);
    },
    getQuizzesList(whenDone) {
      const self = this;
      self.quizzesLoading = true;

      var onSuccess = function(response) {
        self.quizzes = response.data.map((item) => {return {label: item.text, value: item.value} });

        if (whenDone && typeof whenDone == "function") {
          whenDone();
        }
      };
      var onFinally = function () {
        self.quizzesLoading = false;
      };

      self.$ajaxGet(self, "Quiz/GetSelectListJournals", onSuccess, onFinally);
    },
    getQuizQuestions(whenDone){
      const self = this;

      var onSuccess = function(response) {
        self.showQuestions = true;
        self.questions = response.data.map(x => { return {label: `${x.number}. ${x.title}`, value: x.quizQuestionId} });

        if (whenDone && typeof whenDone == "function") {
          whenDone();
        }
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.sidebarScrollArea.$el);
      };

      if(self.quizDropdown){
        self.showLoadingOnSidebar();
        self.$ajaxGet(self, "Quiz/GetQuestionsForVideoQuiz?quizId=" + self.quizDropdown.value, onSuccess, onFinally);
      }
    },
    getVideo() {
      const self = this;

      if (self.videoDropdown) {
        var url = self.videoDropdown.url;

        var oldVideoElement = document.getElementsByClassName("video-js")[0];
        if (oldVideoElement) {
          oldVideoElement.remove();
        }
        var videoContainerDiv = document.getElementById("videojs-container");
        var videoElement = document.createElement('video');
        videoElement.id = "video-quiz-video-player";
        videoElement.classList.add('video-js');
        videoElement.setAttribute('controls', true);
        videoContainerDiv.appendChild(videoElement);

        var videoElement = document.getElementById("video-quiz-video-player");


        var searchMask = "/index.m3u8";
        var regEx = new RegExp(searchMask, "ig");
        var replaceMask = ".mp4";

        var player = videojs(videoElement);

        if (!url.includes(".mp4")){
          setTimeout(function(){
            url = url.replace(regEx, replaceMask);
            player.src({ type: "video/mp4", src: url});
            setTimeout(function() {
              self.setVideoLength();
            },200);
          },200)
        }
        else if (url.includes(".mp4")) {
          setTimeout(function(){
            player.src({ type: "video/mp4", src: url});
            setTimeout(function() {
              self.setVideoLength();
            },200);
          },200)
        }
      }
    },
    hideElements() {
      
    },
    setVideoLength() {
      var vid = document.getElementById("video-quiz-video-player_html5_api");
      this.videoLengthSecs = vid.duration;
      if (this.videoLengthSecs) {
        this.videoLengthString = new Date(this.videoLengthSecs * 1000).toISOString().substr(11, 8);
      }
    },
    saveData(val,taskTypeId){
      this.$emit('saveData',val,taskTypeId);
      this.$vs.loading.close(this.$refs.addupdateButton.$el);
      this.initValues(val);
    },
    addOptions() {
      this.formData.questions.push({
        quizQuestionId: 0,
        number: 0,
        title: '',
        time: '',
        dropdownValue: 0
      });
      var scrollOptions = {
        container: '#taskDetails',
        easing: 'ease-in',
        offset: 1000000,
        force: true,
        cancelable: true,
        x: false,
        y: true
      }
      var cancelScroll = this.$scrollTo(this.$refs["optionsAdd"], 500, scrollOptions);
    },
    deleteRow(index) {
      this.formData.questions.splice(index,1)
    },
    addEditVideoQuiz() {
      this.$validator.validateAll().then(result => {
        var self = this;
        if (result) {
          self.showLoadingOnButton();
          self.invalidTimes = [];

          self.formData.questions.forEach(item => {
            item.quizQuestionId = item.dropdownValue.value;
          });

          self.formData.questions.forEach(item => {
            if (item.time && self.videoLengthSecs) {
              var inputTimeMs = Number(item.time.split(':')[0]) * 60 * 1000 + Number(item.time.split(':')[1]) * 1000;

              if (inputTimeMs > (self.videoLengthSecs * 1000)){
                self.invalidTimes.push({
                  question: item.dropdownValue.label,
                  message: "Input time may not be greater than the overall length of the selected video"
                })
              }
            } else if (item.dropdownValue && self.videoLengthSecs) {
              self.invalidTimes.push({
                question: item.dropdownValue.label,
                message: "Time cannot be empty"
              })
            } else if (self.videoLengthSecs) {
              self.invalidTimes.push({
                question: "No question selected",
                message: "A question is required"
              })
            }
          });

          if (self.invalidTimes.length > 0) {
            self.invalidTimes.forEach(e => {
              self.$vs.notify({
                title: `Error at: ${e.question}`,
                color: "danger",
                text: e.message,
                position:'top-right',
                iconPack: 'feather',
                icon:'icon-x',
                time: 4000
              });
            });
            setTimeout(function() {
              self.$vs.loading.close(self.$refs.addupdateButton.$el);
            }, 200)
            return;
          }

          self.formData.moduleId = self.moduleId;
          self.formData.videoId = parseInt(self.videoDropdown.value);
          self.formData.quizId = parseInt(self.quizDropdown.value);

          var onSuccess = response => {
            if(self.gotoRadio == "newTask"){
              self.saveData( response.data, self.formData.taskTypeId );
            }
            else {
              self.saveData(0, self.formData.taskTypeId);
              self.$vs.notify({
                title:'Information',
                color: "success",
                text: "Task Saved",
                position:'top-right',
                iconPack: 'feather',
                icon:'icon-save'
              });
            }
          };
          var onFinally = function () {
            self.$vs.loading.close(self.$refs.addupdateButton.$el);
          };

          if(self.gotoRadio == "none" || self.gotoRadio == "newTask"){
            self.formData.goTo = "0";
          } else if (self.gotoRadio == "existingTask"){
          }
          self.formData.unitStandardId = self.unitStandardDropdown ? self.unitStandardDropdown.value: null

          self.formData.essentialEmbeddedKnowledgeId = self.essentialEmbeddedKnowledgeDropdown ? self.essentialEmbeddedKnowledgeDropdown.value: null;

          self.formData.assessmentCriteriaId = self.assessmentCriteriaDropdown ?  self.assessmentCriteriaDropdown.value: null;

          self.formData.spesificOutcomeId = self.spesificOutcomeDropdown ?  self.spesificOutcomeDropdown.value: null;

          self.formData.taskClassificationTypeId = self.taskClassificationTypeDropdown ? self.taskClassificationTypeDropdown.value: null;

          self.$ajaxPost(self, "VideoQuizTask/AddEditVideoQuizTask", self.formData, onSuccess, onFinally);
        }
      });
      var scrollOptions = {
        container: '#taskDetails',
        easing: 'ease-in',
        offset: -1000,
        force: true,
        cancelable: true,
        x: false,
        y: true
      }
      var cancelScroll = this.$scrollTo(this.$refs["nameLabel"], 500, scrollOptions);
    },
    deleteTask() {
      var self = this;
      self.showLoadingOnDeleteButton();
      if(self.formData.hasLogs)
        self.showLoadingOnCytoscape();

      var onSuccess = response => {
        self.saveData();
        self.initValues();
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Task Deleted",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-trash'
        });
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.deleteButton.$el);
        self.$vs.loading.close(self.$parent.$el);
      };

      self.$ajaxDelete(self, "VideoQuizTask/DeleteVideoQuizTask/" + self.formData.id, onSuccess, onFinally);
    },
    showLoadingOnButton(){
      var self = this;
      self.$vs.loading({
        background: self.backgroundLoading,
        type: "material",
        container: self.$refs.addupdateButton.$el,
        scale: 0.45
      });
    },
    showLoadingOnSidebar(){
      var self = this;
      self.$vs.loading({
        background: self.backgroundLoading,
        type: "material",
        container: self.$refs.sidebarScrollArea.$el,
        scale: 1
      });
    },
    showLoadingOnDeleteButton(){
      var self = this;
      self.$vs.loading({
        background: self.backgroundLoading,
        type: "material",
        container: self.$refs.deleteButton.$el,
        scale: 0.45
      });
    },
    showLoadingOnCytoscape(){
      var self = this;
      self.$vs.loading({
        type: "corners",
        container: self.$parent.$el,
        scale: 1
      });
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    deleteApproach() {
      if(this.formData.hasLogs)
        this.openConfirm();
      else
        this.deleteTask();
    },
    openConfirm() {
      this.$emit("closeSidebar");
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Attention`,
        text: 'Are you sure you want to delete the selected video quiz task?',
        accept: this.deleteTask,
        acceptText: "Yes, delete",
        cancelText: "No, cancel"
      })
    }
  },
  mounted() {
    
  }
};
</script>
<style type="stylesheet">
@import "https://unpkg.com/video.js/dist/video-js.min.css";
</style>
<style lang="scss" scoped>
  .add-new-data-sidebar {
    /deep/ .vs-sidebar--background {
      z-index: 52010;
    }
    /deep/ .vs-sidebar {
      z-index: 52010;
      width: 400px;
      max-width: 90vw;
      .img-upload {
        margin-top: 2rem;
        .con-img-upload {
          padding: 0;
        }
        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }
  .scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
  }

  #remove-option-button {
    position: absolute;
    top: 5px;
    right: 5px;
  }
</style>
